<template>
  <!-- <v-dialog v-model="dialog" retain-focus>
  <template v-slot:activator="{ on }"></template>-->
  <v-container grid-list-xl class="px-5">
    <v-row wrap class="px-5">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card flat class="pa-5">
          <v-row no-gutters class="pa-5">
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-card flat class="py-5 transparent" style="margin-top:10%; margin-bottom:10%">
                <v-card-title primary-title class="row">
                  <div class="display-1 font-weight-bold text-left">
                    Elearning<br /><span class="primary--text">Program Guru Penggerak</span>
                  </div>
                </v-card-title>
                <v-card-text class="row pt-5 pb-5">
                  <div class="text-left mb-5">
                    Selamat datang {{ current_user.nama }} di SIM ELearning Program Guru Penggerak, untuk informasi
                    lebih lanjut mengenai program ini silakan kunjungi tautan berikut
                  </div>
                  <v-btn
                    style=" webkit-box-shadow: 0px 0px 10px 5px rgb(231, 230, 230);"
                    class="secondary mr-3 pa-5 mt-5 text-capitalize"
                    large
                    width="40%"
                    elevation="10"
                    @click="toPortal"
                    >Informasi
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="6" v-if="$vuetify.breakpoint.mdAndUp">
              <v-card flat class="pa-2 transparent">
                <v-card-title primary-title class="row justify-center">
                  <img
                    src="https://penggerak-cdn.siap.id/s3/gurupenggerak/hero-gp-dt.png"
                    alt="GuruPenggerak.id"
                    width="100%"
                  />
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-text>
            <v-row row class="mt-2">
              <v-col cols="12" sm="12" md="8" class="pb-0"></v-col>
              <v-col cols="12" sm="12" md="4" class="pb-0">
                <v-text-field
                  class="mx-3"
                  outlined
                  dense
                  autofocus
                  v-model="textSearch"
                  placeholder="Cari Instansi"
                  hint
                  clearable
                  append-icon="mdi-magnify"
                  @click:append="pencarian()"
                  @keyup.enter="pencarian()"
                  @click:clear="pencarian(0)"
                  persistent-hint
                  :error-messages="errors.collect('form.instansi')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pa-3" v-for="item in items" :key="item.id">
                <BlockCard
                  :item="item"
                  :title="item.nama"
                  :height="185"
                  color="primary"
                  @reload="load"
                  @edit="edit(item)"
                  @pilih="pilihInstansi(item)"
                  to
                />
              </v-col>
            </v-row>
            <v-row wrap class="pb-0" v-if="page && page.last_page > 1">
              <v-pagination
                v-if="page.total"
                v-model="current_page"
                :length="page.last_page"
                :total-visible="6"
                @input="change"
              ></v-pagination>
            </v-row>
          </v-card-text>

          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Form ref="dlg" />
  </v-container>
  <!-- </v-dialog> -->
</template>

<script>
import { PORTAL } from "@/const";
import BlockCard from "@/components/BlockCard";
import Form from "../components/Form";

export default {
  components: {
    BlockCard,
    Form
  },
  data() {
    return {
      instansi: {},
      textSearch: "",
      items: [],
      current_page: 1,
      hsidebar: false,
      page: null,
      cp: 1,
      dialog: true
    };
  },
  activated() {
    this.dialog = true;
  },
  mounted() {
    this.$store.commit("main/setLDrawer", false);
    this.current_page = 1;
    this.load();
  },
  methods: {
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    pencarian(val) {
      if (val == 0) {
        this.textSearch = null;
      }
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    load() {
      return this.$store
        .dispatch("instansi/get", {
          page: this.current_page,
          s: this.textSearch
        })
        .then(res => {
          this.page = res;
          this.items = res.data;

          // if (res.data.length == 1) {
          //   this.pilihInstansi(res.data[0]);
          // }
        })
        .catch(e => e);
    },
    toPortal() {
      window.open(PORTAL, "_blank");
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("instansi/create", this.instansi);
        })
        .then(res => {
          this.instansi.nama = "";
          this.pilihInstansi(res.data);
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    },
    change() {
      this.load();
    },
    pilihInstansi(item) {
      return this.$store
        .dispatch("instansi/switchInstansi", item.id)
        .then(() => {
          this.$store.commit("main/setLDrawer", true);
          return this.$router.push({
            name: "beranda",
            params: { instansi_id: item.id }
          });
        })
        .catch(e => e);
    }
  },
  watch: {
    hsidebar(n) {
      this.$store.commit("main/setHsidebar", n);
    }
  },
  computed: {
    is_disabled() {
      return this.CONFIG.SINGKRONISASI == "true" ? true : false;
    }
  }
};
</script>

<style></style>
